import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import IconTiStar from '@components/Images/IconTiStar';
import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import AiAlertSubscriptions from './AiAlertSubscriptions';
import AiThreads from './AiThreads';
import Help from './Help/index';
import Nav from './Nav';
import { DeepResearchSettingsProps } from './interfaces';

const queryClient = new QueryClient();

const DeepResearchSettings = ({
  env,
  initialCurrentUser,
  isWebview,
}: DeepResearchSettingsProps) => {
  const { Track } = useEventTracking({
    page: Page.DeepResearchSettings,
  });

  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Track>
          <main id="settings" className="container">
            <div className="grid grid-flow-row grid-cols-1 lg:grid-flow-col lg:grid-cols-12">
              <div className="hidden lg:col-span-3 lg:block">
                <Nav />
              </div>
              <div className="col-span-12 !px-16 lg:col-span-9">
                <header className="border-0 border-b border-solid border-grayscale-beige pb-12">
                  <h1 className="flex items-center font-suisse-works text-headline-xxs">
                    <IconTiStar className="mb-6 mr-3" />
                    Deep Research settings
                  </h1>
                  <p className="mb-4 mt-28 font-suisse-intl text-description-sm">
                    TI Deep Research can make mistakes. Check important information.
                  </p>
                </header>

                <AiAlertSubscriptions />
                <AiThreads />
                <Help />
              </div>
            </div>
          </main>
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default DeepResearchSettings;
